import { useEffect, useMemo, useState } from "react";
import { Col } from "reactstrap";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faPenToSquare,
  faTrash,
  faEye,
} from "@fortawesome/free-solid-svg-icons";
import { APISD } from "../../../../../../config/apisd";
import ModalFormUlangan from "../modal/ModalUlangan";

export default function UlanganTab({
  selectedMatpel,
  selectedAcademicYearId,
  setSelectedUlangan,
  selectedSemesterId,
  getToken,
  getUserId,
  getBranchId,
  getSchoolId,
  nameCollator,
  ToastSuccess,
  ToastError,
}) {
  const [ulanganData, setUlanganData] = useState([]);
  const [searchUlangan, setSearchUlangan] = useState("");
  const [showModalUlangan, setShowModalUlangan] = useState(false);
  const [editUlanganId, setEditUlanganId] = useState(null);
  const [isFetchingUlangan, setIsFetchingUlangan] = useState(false);
  const [isSubmittingUlangan, setIsSubmittingUlangan] = useState(false);
  const [deletingUlanganId, setDeletingUlanganId] = useState(null);

  const [cpDataByMatpel, setCpDataByMatpel] = useState({});
  const [tpDataByCp, setTpDataByCp] = useState({});
  const [isFetchingTp, setIsFetchingTp] = useState(false);

  const [learningTypeData, setLearningTypeData] = useState([]);
  const [isFetchingLearningType, setIsFetchingLearningType] = useState(false);

  const [formUlangan, setFormUlangan] = useState({
    title: "",
    discuss: true,
    notofication: true,
    hide_exam: false,
    hide_exam_value: false,
    description: "",
    file_exam: null,
    ysb_kelas_id: [],
    items: [],
    ysb_matpel_cp_id: "",
    ysb_matpel_tp_id: "",
    ysb_matpel_tp_ids: [],
    ysb_learning_type_id: "",
  });

  const safeStr = (value) =>
    value === null || value === undefined ? "" : String(value);

  const normalizeBool = (value) => {
    return (
      value === true ||
      value === 1 ||
      value === "1" ||
      value === "true"
    );
  };

  const getAuthHeaders = () => ({
    Authorization: getToken?.() || "",
    "Content-Type": "application/json",
  });

  const getArrayFromResponse = (responseData) => {
    if (Array.isArray(responseData?.data?.data)) return responseData.data.data;
    if (Array.isArray(responseData?.data)) return responseData.data;
    if (Array.isArray(responseData?.result)) return responseData.result;
    if (Array.isArray(responseData)) return responseData;
    return [];
  };

  const formatDate = (value) => {
    if (!value) return "-";

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;

    return date.toLocaleDateString("id-ID", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const formatTime = (value) => {
    if (!value) return "";
    return safeStr(value).slice(0, 5);
  };

  const getSelectedMatpelId = () => {
    return selectedMatpel?.ysb_matpel_id || selectedMatpel?.id || "";
  };

  const getSelectedKelasIds = () => {
    if (Array.isArray(selectedMatpel?.selected_kelas_ids)) {
      return selectedMatpel.selected_kelas_ids.map(String);
    }

    return (selectedMatpel?.kelas_list || [])
      .map((kelas) => kelas?.ysb_kelas_id)
      .filter(Boolean)
      .map(String);
  };

  const getKelasNameById = (kelasId) => {
    const found = (selectedMatpel?.kelas_list || []).find(
      (kelas) => String(kelas?.ysb_kelas_id) === String(kelasId)
    );

    return (
      found?.nama_kelas ||
      found?.name_kelas ||
      found?.kelas_name ||
      found?.name ||
      "Kelas"
    );
  };

  const getLearningTypeLabel = (value) => {
    if (!value) return "-";

    const found = (learningTypeData || []).find(
      (item) =>
        String(item?.id) === String(value) ||
        String(item?.name_learning) === String(value) ||
        String(item?.slug_name) === String(value)
    );

    return found?.name_learning || value || "-";
  };

  const getKelasScheduleText = (item) => {
    const kelasList = Array.isArray(item?.kelas_list) ? item.kelas_list : [];

    if (kelasList.length === 0) {
      if (item?.date_exam || item?.time_exam) {
        return `${formatDate(item?.date_exam)}${
          item?.time_exam ? `, ${formatTime(item.time_exam)}` : ""
        }`;
      }

      return "-";
    }

    return kelasList
      .map((kelas) => {
        const namaKelas =
          kelas?.name_kelas ||
          kelas?.nama_kelas ||
          kelas?.kelas_name ||
          getKelasNameById(kelas?.ysb_kelas_id);

        const tanggal = kelas?.date_exam ? formatDate(kelas.date_exam) : "-";
        const jam = kelas?.time_exam ? formatTime(kelas.time_exam) : "";

        return `${namaKelas}: ${tanggal}${jam ? `, ${jam}` : ""}`;
      })
      .join(" | ");
  };

  const groupCpByMatpel = (rows = []) => {
    return rows.reduce((acc, item) => {
      const matpelId =
        item?.ysb_matpel_id ||
        item?.matpel_id ||
        item?.id_matpel ||
        "tanpa_matpel";

      if (!acc[matpelId]) acc[matpelId] = [];

      acc[matpelId].push({
        id: item?.id,
        ysb_fase_id: item?.ysb_fase_id || "",
        ysb_academic_year_id: item?.ysb_academic_year_id || "",
        ysb_semester_id: item?.ysb_semester_id || "",
        ysb_branch_id: item?.ysb_branch_id || "",
        ysb_school_id: item?.ysb_school_id || "",
        ysb_grade_level_id: item?.ysb_grade_level_id || "",
        ysb_kelas_id: item?.ysb_kelas_id || "",
        ysb_matpel_id: item?.ysb_matpel_id || matpelId,
        nama_cp: item?.name_cp || item?.nama_cp || "",
        topik: item?.name_topic || item?.topik || "",
        keterangan: item?.description || item?.keterangan || "",
        raw: item,
      });

      return acc;
    }, {});
  };

  const groupTpByCp = (rows = []) => {
    return rows.reduce((acc, item) => {
      const cpId =
        item?.ysb_matpel_cp_id ||
        item?.matpel_cp_id ||
        item?.cp_id ||
        "tanpa_cp";

      if (!acc[cpId]) acc[cpId] = [];

      acc[cpId].push({
        id: item?.id,
        ysb_matpel_cp_id: item?.ysb_matpel_cp_id || cpId,
        tp: item?.name_tp || item?.tp || "",
        keterangan: item?.name_information || item?.keterangan || "",
        raw: item,
      });

      return acc;
    }, {});
  };

  const isSameSelectedCpContext = (item) => {
    const selectedMatpelId = getSelectedMatpelId();
    const selectedGradeLevelId = selectedMatpel?.ysb_grade_level_id || "";
    const selectedKelasIds = getSelectedKelasIds();

    const itemMatpelId =
      item?.ysb_matpel_id ||
      item?.matpel_id ||
      item?.id_matpel ||
      item?.raw?.ysb_matpel_id ||
      "";

    const itemGradeLevelId =
      item?.ysb_grade_level_id ||
      item?.grade_level_id ||
      item?.raw?.ysb_grade_level_id ||
      "";

    const itemAcademicYearId =
      item?.ysb_academic_year_id ||
      item?.academic_year_id ||
      item?.raw?.ysb_academic_year_id ||
      "";

    const itemSemesterId =
      item?.ysb_semester_id ||
      item?.semester_id ||
      item?.raw?.ysb_semester_id ||
      "";

    const itemKelasIds = Array.isArray(item?.kelas_list)
      ? item.kelas_list
          .map((kelas) => kelas?.ysb_kelas_id)
          .filter(Boolean)
          .map(String)
      : item?.ysb_kelas_id
      ? [String(item.ysb_kelas_id)]
      : [];

    const sameMatpel = String(itemMatpelId) === String(selectedMatpelId);

    const sameGrade =
      !selectedGradeLevelId ||
      !itemGradeLevelId ||
      String(itemGradeLevelId) === String(selectedGradeLevelId);

    const sameKelas =
      itemKelasIds.length === 0 ||
      selectedKelasIds.length === 0 ||
      itemKelasIds.some((kelasId) => selectedKelasIds.includes(String(kelasId)));

    const sameAcademicYear =
      !itemAcademicYearId ||
      !selectedAcademicYearId ||
      String(itemAcademicYearId) === String(selectedAcademicYearId);

    const sameSemester =
      !itemSemesterId ||
      !selectedSemesterId ||
      String(itemSemesterId) === String(selectedSemesterId);

    return sameMatpel && sameGrade && sameKelas && sameAcademicYear && sameSemester;
  };

  const normalizeUlanganRows = (rows = []) => {
    return rows
      .filter((item) => isSameSelectedCpContext(item))
      .map((item) => {
        const tpList = Array.isArray(item?.tp_list) ? item.tp_list : [];
        const kelasList = Array.isArray(item?.kelas_list)
          ? item.kelas_list
          : Array.isArray(item?.items)
          ? item.items
          : [];

        const tpIds = Array.isArray(item?.ysb_matpel_tp_ids)
          ? item.ysb_matpel_tp_ids
          : tpList.length > 0
          ? tpList.map((tp) => tp?.ysb_matpel_tp_id).filter(Boolean)
          : item?.ysb_matpel_tp_id
          ? [item.ysb_matpel_tp_id]
          : [];

        const kelasIds =
          kelasList.length > 0
            ? kelasList.map((kelas) => kelas?.ysb_kelas_id).filter(Boolean)
            : item?.ysb_kelas_id
            ? [item.ysb_kelas_id]
            : [];

        return {
          id: item?.id,
          ysb_kelas_id: kelasIds,
          ysb_grade_level_id: item?.ysb_grade_level_id || "",
          ysb_matpel_id: item?.ysb_matpel_id || "",
          ysb_matpel_cp_id: item?.ysb_matpel_cp_id || "",
          ysb_matpel_tp_id: tpIds?.[0] || item?.ysb_matpel_tp_id || "",
          ysb_matpel_tp_ids: tpIds,
          ysb_learning_type_id: item?.ysb_learning_type_id || "",
          title: item?.title || "",
          discuss: item?.discuss ?? true,
          notofication: item?.notofication ?? false,
          hide_exam: item?.hide_exam ?? false,
          hide_exam_value: item?.hide_exam_value ?? false,
          description: item?.description || "",
          file_exam: item?.file_exam || "",
          date_exam: item?.date_exam || kelasList?.[0]?.date_exam || "",
          time_exam: item?.time_exam || kelasList?.[0]?.time_exam || "",
          date_create_exam: item?.date_create_exam || item?.created_at || "",
          type_name:
            item?.type_name ||
            item?.learning_type_name ||
            item?.ysb_learning_type?.name_learning ||
            item?.ysb_learning_type?.name ||
            item?.learning_type?.name_learning ||
            item?.learning_type?.name ||
            item?.ysb_learning_type_id ||
            "-",
          collected_total:
            item?.collected_total ||
            item?.total_collected ||
            item?.sudah_dikumpul ||
            0,
          collected_target:
            item?.collected_target ||
            item?.total_student ||
            item?.total_siswa ||
            0,
          scored_total:
            item?.scored_total ||
            item?.total_scored ||
            item?.sudah_dinilai ||
            0,
          scored_target:
            item?.scored_target ||
            item?.total_student ||
            item?.total_siswa ||
            0,
          remedial_value: item?.remedial_value || item?.nilai_remedial || "-",
          tp_list: tpList,
          kelas_list: kelasList,
          raw: item,
        };
      });
  };

  const getCpData = async () => {
    try {
      const response = await APISD.get("/api/matpels-cp", {
        headers: getAuthHeaders(),
        params: {
          page: 1,
          limit: 1000,
          ascending: 0,
          search: "",
          branch: "",
          level: localStorage.getItem("level") || "developer",
        },
      });

      setCpDataByMatpel(groupCpByMatpel(getArrayFromResponse(response?.data)));
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title: error?.response?.data?.message || "Gagal mengambil data CP",
      });
    }
  };

  const getTpData = async () => {
    setIsFetchingTp(true);

    try {
      const response = await APISD.get("/api/matpels-tp", {
        headers: getAuthHeaders(),
        params: {
          page: 1,
          limit: 1000,
          ascending: 0,
          search: "",
          branch: "",
          level: localStorage.getItem("level") || "developer",
        },
      });

      setTpDataByCp(groupTpByCp(getArrayFromResponse(response?.data)));
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title: error?.response?.data?.message || "Gagal mengambil data TP",
      });
    } finally {
      setIsFetchingTp(false);
    }
  };

  const getLearningTypeData = async () => {
    setIsFetchingLearningType(true);

    try {
      const response = await APISD.get("/api/learning-types", {
        headers: getAuthHeaders(),
        params: {
          page: 1,
          limit: 1000,
          ascending: 0,
          search: "",
        },
      });

      const rows = getArrayFromResponse(response?.data);

      setLearningTypeData(
        rows.map((item) => ({
          id: item?.id || item?.ysb_learning_type_id || "",
          name_learning:
            item?.name_learning ||
            item?.name ||
            item?.title ||
            item?.slug_name ||
            "-",
          slug_name: item?.slug_name || "",
          raw: item,
        }))
      );
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title:
          error?.response?.data?.message || "Gagal mengambil tipe ulangan",
      });
    } finally {
      setIsFetchingLearningType(false);
    }
  };

  const getUlanganData = async () => {
    if (!selectedMatpel?.id) return;

    setIsFetchingUlangan(true);

    try {
      const response = await APISD.get("/api/matpels-exam", {
        headers: getAuthHeaders(),
        params: {
          page: 1,
          limit: 1000,
          ascending: 0,
          search: "",
          branch: "",
          level: localStorage.getItem("level") || "developer",
        },
      });

      setUlanganData(normalizeUlanganRows(getArrayFromResponse(response?.data)));
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title: error?.response?.data?.message || "Gagal mengambil data ulangan",
      });
      setUlanganData([]);
    } finally {
      setIsFetchingUlangan(false);
    }
  };

  useEffect(() => {
    if (selectedMatpel?.id) {
      getCpData();
      getTpData();
      getLearningTypeData();
      getUlanganData();
      resetFormUlangan();
      setSearchUlangan("");
    }
  }, [
    selectedMatpel?.id,
    selectedMatpel?.ysb_grade_level_id,
    selectedAcademicYearId,
    selectedSemesterId,
  ]);

  const currentCpData = useMemo(() => {
    if (!selectedMatpel?.id) return [];

    const matpelId = selectedMatpel?.ysb_matpel_id || selectedMatpel?.id;
    const rows = cpDataByMatpel[matpelId] || [];

    return rows.filter(isSameSelectedCpContext);
  }, [
    cpDataByMatpel,
    selectedMatpel,
    selectedAcademicYearId,
    selectedSemesterId,
  ]);

  const filteredUlanganData = useMemo(() => {
    const q = (searchUlangan || "").trim().toLowerCase();

    const base = !q
      ? ulanganData || []
      : (ulanganData || []).filter((item) => {
          const title = safeStr(item?.title).toLowerCase();
          const typeName = safeStr(
            getLearningTypeLabel(item?.ysb_learning_type_id || item?.type_name)
          ).toLowerCase();
          const description = safeStr(item?.description).toLowerCase();
          const kelasSchedule = safeStr(getKelasScheduleText(item)).toLowerCase();

          return (
            title.includes(q) ||
            typeName.includes(q) ||
            description.includes(q) ||
            kelasSchedule.includes(q)
          );
        });

    return [...base].sort((a, b) =>
      nameCollator.compare(
        safeStr(a?.title).trim(),
        safeStr(b?.title).trim()
      )
    );
  }, [ulanganData, searchUlangan, nameCollator, learningTypeData]);

  const resetFormUlangan = () => {
    setFormUlangan({
      title: "",
      discuss: true,
      notofication: true,
      hide_exam: false,
      hide_exam_value: false,
      description: "",
      file_exam: null,
      ysb_kelas_id: [],
      items: [],
      ysb_matpel_cp_id: "",
      ysb_matpel_tp_id: "",
      ysb_matpel_tp_ids: [],
      ysb_learning_type_id: "",
    });

    setEditUlanganId(null);
  };

  const handleChangeFormUlangan = async (e) => {
    const { name, value, type, checked, files } = e.target;

    setFormUlangan((prev) => ({
      ...prev,
      [name]:
        type === "checkbox"
          ? checked
          : type === "file"
          ? files?.[0] || null
          : value,
      ...(name === "ysb_matpel_cp_id"
        ? {
            ysb_matpel_tp_id: "",
            ysb_matpel_tp_ids: [],
          }
        : {}),
    }));

    if (name === "ysb_matpel_cp_id" && value) {
      await getTpData();
    }
  };

  const handleChangeTpUlangan = (tpId) => {
    if (!tpId) return;

    setFormUlangan((prev) => {
      const currentTp = Array.isArray(prev.ysb_matpel_tp_ids)
        ? prev.ysb_matpel_tp_ids
        : [];

      const isChecked = currentTp.includes(tpId);

      const nextTp = isChecked
        ? currentTp.filter((id) => id !== tpId)
        : [...currentTp, tpId];

      return {
        ...prev,
        ysb_matpel_tp_ids: nextTp,
        ysb_matpel_tp_id: nextTp?.[0] || "",
      };
    });
  };

  const handleChangeKelasUlangan = (kelasId) => {
    if (!kelasId) return;

    setFormUlangan((prev) => {
      const currentKelas = Array.isArray(prev.ysb_kelas_id)
        ? prev.ysb_kelas_id
        : [];

      const currentItems = Array.isArray(prev.items) ? prev.items : [];
      const isChecked = currentKelas.includes(kelasId);

      if (isChecked) {
        return {
          ...prev,
          ysb_kelas_id: currentKelas.filter((id) => id !== kelasId),
          items: currentItems.filter(
            (item) => String(item?.ysb_kelas_id) !== String(kelasId)
          ),
        };
      }

      return {
        ...prev,
        ysb_kelas_id: [...currentKelas, kelasId],
        items: [
          ...currentItems,
          {
            ysb_kelas_id: kelasId,
            date_exam: "",
            time_exam: "",
          },
        ],
      };
    });
  };

  const handleSelectAllKelasUlangan = () => {
    const allKelasIds = (selectedMatpel?.kelas_list || [])
      .map((kelas) => kelas?.ysb_kelas_id)
      .filter(Boolean);

    setFormUlangan((prev) => {
      const currentKelas = Array.isArray(prev.ysb_kelas_id)
        ? prev.ysb_kelas_id
        : [];

      const currentItems = Array.isArray(prev.items) ? prev.items : [];

      const isAllSelected =
        allKelasIds.length > 0 &&
        allKelasIds.every((kelasId) => currentKelas.includes(kelasId));

      if (isAllSelected) {
        return {
          ...prev,
          ysb_kelas_id: [],
          items: [],
        };
      }

      return {
        ...prev,
        ysb_kelas_id: allKelasIds,
        items: allKelasIds.map((kelasId) => {
          const existing = currentItems.find(
            (item) => String(item?.ysb_kelas_id) === String(kelasId)
          );

          return (
            existing || {
              ysb_kelas_id: kelasId,
              date_exam: "",
              time_exam: "",
            }
          );
        }),
      };
    });
  };

  const handleChangeJadwalKelasUlangan = (kelasId, field, value) => {
    if (!kelasId) return;

    setFormUlangan((prev) => {
      const currentItems = Array.isArray(prev.items) ? prev.items : [];

      const itemExist = currentItems.some(
        (item) => String(item?.ysb_kelas_id) === String(kelasId)
      );

      const nextItems = itemExist
        ? currentItems.map((item) =>
            String(item?.ysb_kelas_id) === String(kelasId)
              ? {
                  ...item,
                  [field]: value,
                }
              : item
          )
        : [
            ...currentItems,
            {
              ysb_kelas_id: kelasId,
              date_exam: field === "date_exam" ? value : "",
              time_exam: field === "time_exam" ? value : "",
            },
          ];

      return {
        ...prev,
        items: nextItems,
      };
    });
  };

  const handleEditUlangan = (item) => {
    setEditUlanganId(item.id);

    const tpIds = Array.isArray(item?.ysb_matpel_tp_ids)
      ? item.ysb_matpel_tp_ids
      : Array.isArray(item?.tp_list)
      ? item.tp_list
          .map((tp) => tp?.ysb_matpel_tp_id)
          .filter(Boolean)
      : item?.ysb_matpel_tp_id
      ? [item.ysb_matpel_tp_id]
      : [];

    const items = Array.isArray(item?.kelas_list)
      ? item.kelas_list.map((kelas) => ({
          ysb_kelas_id: kelas?.ysb_kelas_id || "",
          date_exam: kelas?.date_exam || "",
          time_exam: kelas?.time_exam || "",
        }))
      : Array.isArray(item?.items)
      ? item.items.map((kelas) => ({
          ysb_kelas_id: kelas?.ysb_kelas_id || "",
          date_exam: kelas?.date_exam || "",
          time_exam: kelas?.time_exam || "",
        }))
      : Array.isArray(item?.ysb_kelas_id)
      ? item.ysb_kelas_id.map((kelasId) => ({
          ysb_kelas_id: kelasId,
          date_exam: item?.date_exam || "",
          time_exam: item?.time_exam || "",
        }))
      : item?.ysb_kelas_id
      ? [
          {
            ysb_kelas_id: item.ysb_kelas_id,
            date_exam: item?.date_exam || "",
            time_exam: item?.time_exam || "",
          },
        ]
      : [];

    setFormUlangan({
      title: item?.title || "",
      discuss: normalizeBool(item?.discuss),
      notofication: normalizeBool(item?.notofication),
      hide_exam: normalizeBool(item?.hide_exam),
      hide_exam_value: normalizeBool(item?.hide_exam_value),
      description: item?.description || "",
      file_exam: null,
      ysb_kelas_id: items.map((kelas) => kelas?.ysb_kelas_id).filter(Boolean),
      items,
      ysb_matpel_cp_id: item?.ysb_matpel_cp_id || "",
      ysb_matpel_tp_id: tpIds?.[0] || "",
      ysb_matpel_tp_ids: tpIds,
      ysb_learning_type_id: item?.ysb_learning_type_id || "",
    });

    setShowModalUlangan(true);
  };

  const handleSubmitUlangan = async (e, publish = false) => {
    e.preventDefault();

    if (!selectedMatpel?.id) {
      ToastError.fire({
        icon: "error",
        title: "Mata pelajaran belum dipilih",
      });
      return;
    }

    if (!formUlangan.title.trim()) {
      ToastError.fire({
        icon: "error",
        title: "Judul ulangan wajib diisi",
      });
      return;
    }

    if (!formUlangan.ysb_matpel_cp_id) {
      ToastError.fire({
        icon: "error",
        title: "CP wajib dipilih",
      });
      return;
    }

    const selectedTpIds = Array.isArray(formUlangan.ysb_matpel_tp_ids)
      ? formUlangan.ysb_matpel_tp_ids
      : [];

    if (selectedTpIds.length === 0) {
      ToastError.fire({
        icon: "error",
        title: "Pilih minimal 1 TP",
      });
      return;
    }

    if (!formUlangan.ysb_learning_type_id) {
      ToastError.fire({
        icon: "error",
        title: "Tipe ulangan wajib dipilih",
      });
      return;
    }

    const selectedKelasIds = Array.isArray(formUlangan.ysb_kelas_id)
      ? formUlangan.ysb_kelas_id
      : [];

    if (selectedKelasIds.length === 0) {
      ToastError.fire({
        icon: "error",
        title: "Pilih minimal 1 kelas",
      });
      return;
    }

    const selectedItems = (formUlangan.items || []).filter((item) =>
      selectedKelasIds.includes(item?.ysb_kelas_id)
    );

    const invalidSchedule = selectedItems.find(
      (item) => !item?.ysb_kelas_id || !item?.date_exam || !item?.time_exam
    );

    if (selectedItems.length !== selectedKelasIds.length || invalidSchedule) {
      ToastError.fire({
        icon: "error",
        title: "Tanggal dan jam wajib diisi untuk setiap kelas yang dipilih",
      });
      return;
    }

    const userId = getUserId?.() || localStorage.getItem("userID") || "";

    setIsSubmittingUlangan(true);

    try {
      const payload = {
        ysb_fase_id: "",
        ysb_academic_year_id: selectedAcademicYearId || "",
        ysb_semester_id: selectedSemesterId || "",
        ysb_branch_id: getBranchId?.() || "",
        ysb_school_id: getSchoolId?.() || "",
        ysb_grade_level_id: selectedMatpel?.ysb_grade_level_id || "",
        ysb_matpel_id: selectedMatpel?.ysb_matpel_id || selectedMatpel?.id || "",
        ysb_matpel_cp_id: formUlangan.ysb_matpel_cp_id || "",
        ysb_matpel_tp_ids: selectedTpIds,
        ysb_learning_type_id: formUlangan.ysb_learning_type_id || "",
        title: formUlangan.title.trim(),
        discuss: formUlangan.discuss ? true : false,
        notofication: publish ? true : formUlangan.notofication ? true : false,
        hide_exam: formUlangan.hide_exam ? true : false,
        hide_exam_value: formUlangan.hide_exam_value ? true : false,
        description: formUlangan.description || "",
        file_exam: "",
        items: selectedItems.map((item) => ({
          ysb_kelas_id: item.ysb_kelas_id,
          date_exam: item.date_exam,
          time_exam: item.time_exam,
        })),
        user_id: userId,
      };

      let response;

      if (editUlanganId) {
        response = await APISD.put(`/api/matpels-exam/${editUlanganId}`, payload, {
          headers: getAuthHeaders(),
        });
      } else {
        response = await APISD.post("/api/matpels-exam/store", payload, {
          headers: getAuthHeaders(),
        });
      }

      ToastSuccess.fire({
        icon: "success",
        title:
          response?.data?.message ||
          (editUlanganId
            ? "Data ulangan berhasil diupdate"
            : "Data ulangan berhasil disimpan"),
      });

      resetFormUlangan();
      setShowModalUlangan(false);
      await getUlanganData();
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title:
          error?.response?.data?.message ||
          (editUlanganId
            ? "Gagal update data ulangan"
            : "Gagal menyimpan data ulangan"),
      });
    } finally {
      setIsSubmittingUlangan(false);
    }
  };

  const handleDeleteUlangan = (item) => {
    Swal.fire({
      title: "Apakah Kamu Yakin?",
      text: "Data ulangan yang dihapus tidak bisa dikembalikan",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ya, Hapus",
      cancelButtonText: "Batal",
    }).then(async (result) => {
      if (!result.isConfirmed) return;

      setDeletingUlanganId(item.id);

      try {
        const response = await APISD.delete(`/api/matpels-exam/${item.id}`, {
          headers: getAuthHeaders(),
        });

        ToastSuccess.fire({
          icon: "success",
          title: response?.data?.message || "Data ulangan berhasil dihapus",
        });

        await getUlanganData();

        if (editUlanganId === item.id) {
          resetFormUlangan();
          setShowModalUlangan(false);
        }
      } catch (error) {
        ToastError.fire({
          icon: "error",
          title:
            error?.response?.data?.message || "Gagal menghapus data ulangan",
        });
      } finally {
        setDeletingUlanganId(null);
      }
    });
  };

  const StatusPill = ({ active, trueText, falseText }) => {
    const isActive = normalizeBool(active);

    return (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: 999,
          padding: "5px 10px",
          fontSize: 12,
          fontWeight: 700,
          background: isActive ? "#dcfce7" : "#fee2e2",
          color: isActive ? "#15803d" : "#dc2626",
          whiteSpace: "nowrap",
        }}
      >
        {isActive ? trueText : falseText}
      </span>
    );
  };

  return (
    <>
      <ModalFormUlangan
        show={showModalUlangan}
        onHide={() => {
          if (isSubmittingUlangan) return;
          setShowModalUlangan(false);
          resetFormUlangan();
        }}
        editUlanganId={editUlanganId}
        formUlangan={formUlangan}
        handleChangeFormUlangan={handleChangeFormUlangan}
        handleSubmitUlangan={handleSubmitUlangan}
        isSubmittingUlangan={isSubmittingUlangan}
        selectedMatpel={selectedMatpel}
        currentCpData={currentCpData}
        tpDataByCp={tpDataByCp}
        isFetchingTp={isFetchingTp}
        learningTypeData={learningTypeData}
        isFetchingLearningType={isFetchingLearningType}
        handleChangeTpUlangan={handleChangeTpUlangan}
        handleChangeKelasUlangan={handleChangeKelasUlangan}
        handleSelectAllKelasUlangan={handleSelectAllKelasUlangan}
        handleChangeJadwalKelasUlangan={handleChangeJadwalKelasUlangan}
      />

      <div className="d-flex mt-4 mb-4">
        <div className="at-search">
          <input
            className="at-input"
            placeholder="Cari judul, tipe, kelas, atau deskripsi ulangan"
            value={searchUlangan}
            onChange={(e) => setSearchUlangan(e.target.value)}
          />
        </div>

        <div className="ml-auto">
          <button
            type="button"
            onClick={() => {
              resetFormUlangan();
              setShowModalUlangan(true);
            }}
            className="btn btn-create mr-2"
            style={{
              borderRadius: 12,
              padding: "8px 14px",
              boxShadow: "0 10px 24px rgba(108,99,255,0.18)",
              fontWeight: 600,
            }}
          >
            <FontAwesomeIcon icon={faPlus} /> Buat Ulangan
          </button>
        </div>
      </div>

      <Col xl="12" sm="12">
        <div className="mt-3 body-table">
          <table
            className="table table-hover table-border-style"
            id="basic-datatable"
          >
            <thead>
              <tr>
                <th style={{ width: "130px" }}>Telah Diumumkan</th>
                <th style={{ width: "150px" }}>Nilai Diumumkan</th>
                <th style={{ width: "160px" }}>Tanggal Dibuat</th>
                <th>Judul</th>
                <th style={{ width: "180px" }}>Tipe</th>
                <th style={{ width: "130px" }}>Sudah Dikumpul</th>
                <th style={{ width: "120px" }}>Sudah Dinilai</th>
                <th style={{ width: "120px" }}>Nilai Remedial</th>
                <th style={{ width: "200px" }}>Aksi</th>
              </tr>
            </thead>

            <tbody>
              {isFetchingUlangan ? (
                <tr>
                  <td
                    colSpan="9"
                    className="text-center"
                    style={{ padding: "20px" }}
                  >
                    Mengambil data ulangan...
                  </td>
                </tr>
              ) : filteredUlanganData.length > 0 ? (
                filteredUlanganData.map((item) => (
                  <tr key={item.id}>
                    <td>
                      <StatusPill
                        active={item.notofication}
                        trueText="Sudah"
                        falseText="Belum"
                      />
                    </td>

                    <td>
                      <StatusPill
                        active={!normalizeBool(item.hide_exam_value)}
                        trueText="Sudah"
                        falseText="Belum"
                      />
                    </td>

                    <td>{formatDate(item.date_create_exam)}</td>

                    <td>
                      <div style={{ fontWeight: 700, color: "#111827" }}>
                        {item.title || "-"}
                      </div>

                      {/* {item.description ? (
                        <small
                          style={{
                            display: "block",
                            color: "#6b7280",
                            marginTop: 3,
                          }}
                        >
                          {item.description}
                        </small>
                      ) : null}

                      <small
                        style={{
                          display: "block",
                          color: "#3f5bea",
                          fontWeight: 600,
                          marginTop: 5,
                          whiteSpace: "normal",
                        }}
                      >
                        {getKelasScheduleText(item)}
                      </small> */}
                    </td>

                    <td>
                      {getLearningTypeLabel(
                        item?.ysb_learning_type_id || item?.type_name
                      )}
                    </td>

                    <td>
                      {item.collected_total}/{item.collected_target}
                    </td>

                    <td>
                      {item.scored_total}/{item.scored_target}
                    </td>

                    <td>{item.remedial_value}</td>

                    <td>
                      <div
                        className="d-flex"
                        style={{
                          gap: 6,
                          flexWrap: "wrap",
                        }}
                      >
                        <button
                          type="button"
                          className="btn btn-sm btn-info"
                          onClick={() => setSelectedUlangan(item)}
                          title="Detail"
                        >
                          <FontAwesomeIcon icon={faEye} />
                        </button>

                        <button
                          type="button"
                          className="btn btn-sm btn-warning"
                          onClick={() => handleEditUlangan(item)}
                          title="Edit"
                        >
                          <FontAwesomeIcon icon={faPenToSquare} />
                        </button>

                        <button
                          type="button"
                          className="btn btn-sm btn-danger"
                          onClick={() => handleDeleteUlangan(item)}
                          disabled={deletingUlanganId === item.id}
                          title="Hapus"
                        >
                          {deletingUlanganId === item.id ? (
                            <i className="fa fa-spinner fa-spin" />
                          ) : (
                            <FontAwesomeIcon icon={faTrash} />
                          )}
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="9"
                    className="text-center"
                    style={{ padding: "20px" }}
                  >
                    Data ulangan belum tersedia
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </Col>
    </>
  );
}